import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { CarCatalogItem } from "../../types/Car/CarCatalogItem.interface";
import { allCarCatalogsRequest } from "../../utils/requests/laximo/allCarCatalogsRequest";

/**
 * Каталог автомобиля из Laximo
 */
interface LaximoCatalog {
    name: string;
    options: LaximoCatalogOption[];
    conditionId: string;
    value: string;
}

interface LaximoCatalogOption {
    label: string;
    value: string;
}

const convertationData = (data: LaximoCatalog[]): CarCatalogItem[] => {
    return data.map((item: LaximoCatalog) => ({
        ...item,
        options: item.options.map((it: LaximoCatalogOption) => ({ id: it.value, value: it.label }))
    }));
}

/**
 * Запрос списка каталогов автомобиля
 * @param brandCode - код марки автомобиля
 * @param ssd - хэш поискового запроса
 * @returns 
 */
export const useNextStepRequest = (brandCode: string, setIsLoadingBrands: Dispatch<SetStateAction<boolean>>, ssd?: string): [CarCatalogItem[], boolean] => {
    const [catalog, setCatalog] = useState<CarCatalogItem[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    //Запрос нового списка каталогов при изменении марки автомобиля
    useEffect(() => {
        setIsLoadingBrands(true);
        allCarCatalogsRequest(brandCode, ssd)
            .then(convertationData)
            .then(setCatalog)
            .finally(() => setIsLoadingBrands(false));
    }, [brandCode]);

    //Обновление списка каталогов при изменении хэша поискового запроса
    useEffect(() => {
        setIsLoading(true);
        allCarCatalogsRequest(brandCode, ssd)
            .then(convertationData)
            .then(data => setCatalog(oldCatalog => {
                const oldNames = oldCatalog.map(it => it.name);
                const newNames = data.map(it => it.name);

                //Обновление старых каталогов
                const updatedOldCatalogs = oldCatalog.filter(it => newNames.includes(it.name))
                    .map(it => {
                        const newCatalog = data.find(newIt => newIt.name === it.name);
                        return {
                            ...it,
                            value: newCatalog?.value || '',
                            options: newCatalog?.options.length ? newCatalog.options : it.options
                        };
                    });

                //Добавление новых каталогов
                const newCatalogs = data.filter(it => !oldNames.includes(it.name));

                //Объединение обновленных и новых каталогов
                let allCatalogs = [...updatedOldCatalogs, ...newCatalogs];
                // allCatalogs = allCatalogs.map(it => {
                //         const [isLoading, setIsLoading] = useState(false);
                //         return {
                //             ...it,
                //             loading: [isLoading, setIsLoading],
                //         }
                //     });
                return allCatalogs;
            }))
            .finally(() => setIsLoading(false));
    }, [ssd]);

    return [catalog, isLoading];
};